<template>
  <v-navigation-drawer width="400" v-model="localDrawer" right temporary app>
    <v-list-item style="background-color: #cfd8dc">
      <v-list-item-content>
        <v-list-item-title class="font-weight-medium">Atendimento</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="mt-4">Turma</v-list-item-title>
        <p class="font-weight-light text-justify mb-3">
          {{ visualizarAtendimento.matricula.turma?.descricao }}
        </p>
        <v-list-item-title>Aluno</v-list-item-title>
        <p class="font-weight-light text-justify mb-3">
          {{ visualizarAtendimento.matricula.aluno?.nomecompleto }}
        </p>
        <v-divider></v-divider>
        <v-list-item-title>Profissional</v-list-item-title>
        <p class="font-weight-light text-justify mb-3">
          {{
            visualizarAtendimento.gestao?.profissional?.name ||
            visualizarAtendimento.professor?.nome
          }}
        </p>
        <v-divider></v-divider>
        <p>
          <v-list-item-title>Data/Horário</v-list-item-title>
        </p>
        <p class="font-weight-light text-justify">
          {{ visualizarAtendimento.data_formatada }}
          {{ " - " }}
          {{ visualizarAtendimento.horario ? visualizarAtendimento.horario.descricao : "[- - -]" }}
        </p>

        <div v-for="(item, index) of $constants.fichaEducacaoEspecialDiario" :key="index">
          <div v-if="item.descricao != 'Conteúdo Interdisciplinar'">
            <div v-if="item.form !== 'campos_de_experiencias'">
              <v-list-item-title v-if="visualizarAtendimento[item.form]" class="mt-4 mb-3">
                {{ item.descricao }}
              </v-list-item-title>
              <div v-if="visualizarAtendimento[item.form]" class="font-weight-light text-justify">
                <div
                  v-html="
                    formatTexto(visualizarAtendimento[item.form])
                      ? formatTexto(visualizarAtendimento[item.form])
                      : '- - -'
                  "
                ></div>
              </div>
            </div>
            <div v-else>
              <v-list-item-title v-if="visualizarAtendimento[item.form]" class="mt-4 mb-2">
                <div v-if="visualizarAtendimento.e_aula_infantil == 1">
                  {{ item.descricao }}
                </div>
              </v-list-item-title>
              <div v-for="(el, idx) of visualizarAtendimento[item.form]" :key="idx">
                <p v-if="el" class="font-weight-light text-justify">•{{ el }}</p>
              </div>
            </div>
          </div>
        </div>
        <v-divider></v-divider>
        <v-list-item-title class="mt-4">Presença do Aluno</v-list-item-title>
        <v-list-item-title>
          <v-chip label :color="visualizarAtendimento.aluno_presente === 1 ? 'green' : 'red'" dark>
            {{ visualizarAtendimento.aluno_presente === 1 ? "Aluno Presente" : "Ausente" }}
          </v-chip>
        </v-list-item-title>
        <p
          v-if="visualizarAtendimento.aluno_presente !== 1"
          class="font-weight-light text-justify mt-2"
        >
          <strong>Justificativa da falta:</strong>
          {{ visualizarAtendimento.justificativa || "Sem justificativa." }}
        </p>

        <v-list-item-title class="mt-4">Confirmação do Atendimento</v-list-item-title>
        <v-list-item-title>
          <v-chip label :color="visualizarAtendimento.confirmada === 1 ? 'green' : 'red'" dark>
            {{ visualizarAtendimento.confirmada === 1 ? "Confirmado" : "Não Confirmado" }}
          </v-chip>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-navigation-drawer>
</template>

<script>
import { validate } from "vee-validate";

export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    atendimento: {
      type: Object,
      required: true,
    },
  },
  methods: {
    formatTexto(texto) {
      if (typeof texto !== "string") return "";
      const textoSemColchetes = texto.replace(/\[|\]/g, ""); // Remover colchetes
      const textoSemQuebraDeLinha = textoSemColchetes.replace(/\\n/g, " ").replace(/"/g, ""); // Remover caracteres de nova linha (\n) e aspas
      const textoFormatado = textoSemQuebraDeLinha.replace(/\n/g, "<br>"); // Substituir quebras de linha por HTML <br>
      return textoFormatado.trim() || "- - -";
    },
  },
  watch: {
    value() {
      this.localDrawer = this.value;
    },
    localDrawer() {
      this.$emit("input", this.localDrawer);
    },
  },
  computed: {
    visualizarAtendimento() {
      return this.atendimento;
    },
  },
  data() {
    return {
      localDrawer: this.value,
    };
  },
};
</script>

<style lang="scss" scoped></style>
